import _ from 'lodash';
import documentService from '../../services/documentService';
import Documents from '../../model/document';

const state = {
  baseUrl: '/document-share',
  pagination: {},
  documents: [],
  loading: false,
  document: null,
  documentUrl: null,
  report: [],
  reportLoading: false
};

const actions = {
  uploadDocument({ dispatch, commit }, query = {}, router) {
    dispatch('alert/clear', {}, { root: true });
    const { file, fileName } = query;

    return new Promise((resolve, reject) => {
      documentService
        .getSignedUrl({ filename: fileName, filetype: file.type, file })
        .then(response => {
          documentService
            .uploadDocument({ url: response.data, file })
            .then(res => {
              commit('Nothing', res);
              resolve(res); // Resolve the promise after successful upload
            })
            .catch(e => {
              commit('requestFailed');
              dispatch('common/handleServiceException', { e, router }, { root: true });
              reject(e); // Reject the promise on error
            });
        })
        .catch(e => {
          commit('requestFailed');
          dispatch('common/handleServiceException', { e, router }, { root: true });
          reject(e); // Reject the promise on error
        });
    });
  },
  listDocuments({ dispatch, commit }, { query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('setDocuments', { documents: [], pagination: {} });

    commit('startRequest');

    documentService
      .listDocuments({ query })
      .then(response => {
        commit('setDocuments', { documents: response.data.rows, pagination: response.data.pagination });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  downloadDocumentsReport({ dispatch, commit }, { query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('setReportDocuments', { report: [] });

    commit('startReportRequest');

    documentService
      .listDocuments({ query })
      .then(response => {
        commit('setReportDocuments', { documents: response.data.rows });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  postOne({ dispatch, commit }, { document, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    documentService
      .postOne({ document })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: 'New Document has been uploaded.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  getOne({ dispatch, commit }, { id, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    commit('setDocument', { document: {} });
    documentService
      .getOne({ id })
      .then(response => {
        commit('setDocument', { document: response.data });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  patchOne({ dispatch, commit }, { id, document, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');
    documentService
      .patchOne({ id, newDocument: document })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: 'Document has been updated.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          dispatch('listDocuments', { query: {} });
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  deleteOne({ dispatch, commit }, { id, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    documentService
      .deleteOne({ id })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: ' Document has been deleted.'
          },
          { root: true }
        );
        location.reload();
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  deleteDownloadedDocument({ dispatch, commit }, { fileName, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    documentService
      .deleteDownloadedDocument({ fileName })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'center',
            title: '',
            text: ' Document has been deleted.'
          },
          { root: true }
        );
        location.reload();
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  sendNotifications({ dispatch, commit }, { params, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');
    documentService
      .sendNotifications({ params })
      .then(_response => { })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  startDownload({ dispatch, commit }, { ids, storeId, mobileNumber, router }) {
    return new Promise((resolve, reject) => {
      documentService
        .startDownload({ ids, storeId, mobileNumber })
        .then(response => {
          resolve(response);
        })
        .catch(e => {
          commit('requestFailed');
          dispatch('common/handleServiceException', { e, router }, { root: true });
          reject(e);
        });
    });
  }
};

const getters = {};

const mutations = {
  startRequest(state) {
    state.loading = true;
  },
  startReportRequest(state) {
    state.reportLoading = true;
  },
  requestFailed(state) {
    state.loading = false;
  },
  setDocuments(state, { documents, pagination }) {
    let row = 1;
    state.documents = _.map(documents, document => {
      const newDocuments = new Documents({
        id: document._id, // eslint-disable-line
        rowNum: row,
        documentUrl: document.documentUrl,
        uploadedByName: document.uploadedByName,
        createdAt: document.createdAt,
        regions: document.regions ? document.regions.join(', ') : '',
        clusters: document.clusters ? document.clusters.join(', ') : '',
        storeids: document.storeids ? document.storeids.join(', ') : '',
        formats: document.formats ? document.formats.join(', ') : '',
        startDate: document.startDate,
        endDate: document.endDate,
        documentType: document.documentType ? document.documentType : '',
        active: document.active,
        title: document.title,
        description: document.description,
        remarks: document.remarks
          .map(i => (i?.text?.length > 35 ? `${i?.text.slice(0, 35)}...` : i?.text))
          .join('<br>'),
        completeRemarks: document.remarks
      });
      row += 1;
      return newDocuments;
    });
    state.pagination = pagination;
    state.loading = false;
  },
  setReportDocuments(state, { documents }) {
    let row = 1;
    state.report = _.map(documents, document => {
      const newDocuments = new Documents({
        id: document._id, // eslint-disable-line
        rowNum: row,
        documentUrl: document.documentUrl,
        uploadedByName: document.uploadedByName,
        createdAt: document.createdAt,
        regions: document.regions ? document.regions.join(', ') : '',
        clusters: document.clusters ? document.clusters.join(', ') : '',
        storeids: document.storeids ? document.storeids.join(', ') : '',
        formats: document.formats ? document.formats.join(', ') : '',
        startDate: document.startDate,
        endDate: document.endDate,
        documentType: document.documentType ? document.documentType : '',
        active: document.active,
        title: document.title,
        description: document.description,
        remarks: document.remarks
          .map(i => (i?.text?.length > 35 ? `${i?.text.slice(0, 35)}...` : i?.text))
          .join('<br>'),
        completeRemarks: document.remarks
      });
      row += 1;
      return newDocuments;
    });
    state.reportLoading = false;
  },
  setDocument(state, { document }) {
    state.document = new Documents({
      id: document._id, // eslint-disable-line
      documentUrl: document.documentUrl,
      uploadedByName: document.uploadedByName,
      documentType: document.documentType ? document.documentType : '',
      createdAt: document.createdAt,
      regions: document.regions ? document.regions : [],
      clusters: document.clusters ? document.clusters : [],
      storeids: document.storeids ? document.storeids : [],
      formats: document.formats ? document.formats : [],
      startDate: document.startDate,
      endDate: document.endDate,
      active: document.active,
      title: document.title,
      description: document.description,
      remarks: document.remarks
    });
    state.loading = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
